import React from "react";
import { MetaTitle } from "@catchoftheday/common-vendors";
import { PrivacyContainer } from "@catchoftheday/privacy";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PrivacyPage = function PrivacyPage(_ref) {
  var host = _ref.host;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(MetaTitle, {
    host: host
  }, "Privacy Policy"), ___EmotionJSX(PrivacyContainer, null));
};
export default PrivacyPage;